window.DataPassAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['DataPassServers']);
    var cachedPositionsLookup = {};

    self.getPositionsLookup = function (channel) {
        var defer = $q.defer();
        var params = {};
        if (cachedPositionsLookup[channel]) {
            defer.resolve(cachedPositionsLookup[channel])
        } else {
            _protected.request("channels/" + channel + "/lookups/positions", "GET", params)
                .then(function (res) {
                    if (res.data && res.data.data && res.data.data) {
                        cachedPositionsLookup[channel] = res.data.data.positions_lookups;
                        defer.resolve(res.data.data.positions_lookups || []);
                    } else {
                        defer.reject(res);
                    }
                }, function (err) {
                    defer.reject(err);
                });
        }

        return defer.promise;
    };

    self.getBrandMappedPositionsLookup = function (brandId, channel) {
        var defer = $q.defer();
        var params = {};
        _protected.request("brands/" + brandId + "/channels/" + channel + "/lookups/positions", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data.positions_lookups || []);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.saveBrandMappedPositions = function (brandId, channel, mappedPositionsLookup) {
        var defer = $q.defer();

        var params = {
            positions_lookups: mappedPositionsLookup
        }

        _protected.request("brands/" + brandId + "/channels/" + channel + "/lookups/positions", "PUT", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getPostHireService = function (brandsId) {
        var defer = $q.defer();
        var params = {
            brand_ids: brandsId.join(',')
        };
        _protected.request("brands/services", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data.brands || []);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

});